import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_put } from "services/api";
import { openSnackbar } from "./globalSnackbar";
import { UPDATE_DISPENSER_IMEI, UPDATE_UNIT_TANKS } from "redux/reducers/units_v2/unitsReducer";

// general
const CLEAR_DISPENSERS = "CLEAR_DATA_DISPENSERS";
const SET_SUCCESS_DISPENSERS = "SET_SUCCESS_DISPENSERS";
const CLEAR_ERROR_DISPENSERS = "CLEAR_ERROR_DISPENSERS";
const CLEAR_SUCCESS_DISPENSERS = "CLEAR_SUCCESS_DISPENSERS";
const SET_ERROR_DISPENSERS = "SET_ERROR_DISPENSERS";

// dispensers config
const SEND_DISPENSER_CONFIG_DISPENSERS = "SEND_DISPENSER_CONFIG_DISPENSERS";
const SET_DISPENSER_CONFIG_DISPENSERS = "SET_DISPENSER_CONFIG_DISPENSERS";
const ERROR_DISPENSER_CONFIG_DISPENSERS = "ERROR_DISPENSER_CONFIG_DISPENSERS";

// dispensers config
const SEND_IMEI_DISPENSERS = "SEND_IMEI_DISPENSERS";
const SET_IMEI_DISPENSERS = "SET_IMEI_DISPENSERS";
const ERROR_IMEI_DISPENSERS = "ERROR_IMEI_DISPENSERS";

// config
const SET_CONFIG_PAGE_DISPENSERS = "SET_CONFIG_PAGE_DISPENSERS";
const SET_CONFIG_PAGE_SIZE_DISPENSERS = "SET_CONFIG_PAGE_SIZE_DISPENSERS";
const SET_CONFIG_SORTED_DISPENSERS = "SET_CONFIG_SORTED_DISPENSERS";
const SET_CONFIG_FILTERED_DISPENSERS = "SET_CONFIG_FILTERED_DISPENSERS";

const INITIAL_STATE = {
  isLoading: false,
  error: false,
  success: false,
  message: "",
  errorMessage: "",
  isLoadingDispenserConfig: false,
  isLoadingImei: false,

  // config
  config: {
    page: 0,
    pageSize: 50,
    sorted: [],
    filtered: [],
  },
};

const dispensersReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    //config
    case SET_CONFIG_FILTERED_DISPENSERS:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };
    case SET_CONFIG_PAGE_DISPENSERS:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };
    case SET_CONFIG_PAGE_SIZE_DISPENSERS:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };
    case SET_CONFIG_SORTED_DISPENSERS:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        },
      };

    // Dispenser config
    case SEND_DISPENSER_CONFIG_DISPENSERS:
      return {
        ...state,
        isLoadingDispenserConfig: true,
        error: false,
        errorMessage: "",
      };
    case SET_DISPENSER_CONFIG_DISPENSERS:
      const { id } = payload.dispenser;
      const newDispensers = [...state.dispensers];

      const indexRow = newDispensers.findIndex(
        (dispenser) => dispenser.id === id
      );

      if (indexRow !== -1) {
        newDispensers[indexRow] = payload.dispenser;
      }

      return {
        ...state,
        dispensers: newDispensers,
        isLoadingDispenserConfig: false,
      };
    case ERROR_DISPENSER_CONFIG_DISPENSERS:
      return {
        ...state,
        isLoadingDispenserConfig: false,
        error: true,
        errorMessage: payload.message,
      };
    // Dispenser IMEI
    case SEND_IMEI_DISPENSERS:
      return {
        ...state,
        isLoadingImei: false,
        error: false,
        errorMessage: "",
      };
    case SET_IMEI_DISPENSERS:
      return { ...state, isLoadingImei: false };

    case ERROR_IMEI_DISPENSERS:
      return {
        ...state,
        isLoadingImei: false,
        error: true,
        errorMessage: payload.message,
      };
    // general
    case CLEAR_DISPENSERS:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case SET_SUCCESS_DISPENSERS:
      return {
        ...state,
        success: true,
        message: payload,
      };
    case CLEAR_SUCCESS_DISPENSERS:
      return {
        ...state,
        success: false,
        message: "",
      };
    case CLEAR_ERROR_DISPENSERS:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    case SET_ERROR_DISPENSERS:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };

    default:
      return state;
  }
};

// Actions
function sendDispensersConfig(id, body) {
  return {
    type: SEND_DISPENSER_CONFIG_DISPENSERS,
    payload: {
      id,
      body,
    },
  };
}
function sendImeiDispenserAction(id, body, idUnit) {
  return {
    type: SEND_IMEI_DISPENSERS,
    payload: {
      id,
      body,
      idUnit,
    },
  };
}
// config
function setConfigFilter(filter) {
  return {
    type: SET_CONFIG_FILTERED_DISPENSERS,
    payload: filter,
  };
}
function setConfigPage(page) {
  return {
    type: SET_CONFIG_PAGE_DISPENSERS,
    payload: page,
  };
}
function setConfigPageSize(pageSize) {
  return {
    type: SET_CONFIG_PAGE_SIZE_DISPENSERS,
    payload: pageSize,
  };
}
function setConfigSorted(sorted) {
  return {
    type: SET_CONFIG_SORTED_DISPENSERS,
    payload: sorted,
  };
}
//general
function clearError() {
  return {
    type: CLEAR_ERROR_DISPENSERS,
  };
}
function setSuccess(message) {
  return {
    type: SET_SUCCESS_DISPENSERS,
    payload: message,
  };
}
function clearSuccess() {
  return {
    type: CLEAR_SUCCESS_DISPENSERS,
  };
}

// sagas
function* sendConfigDispenser(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, body },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/dispensers/${id}/configuration`;
  try {
    const response = yield call(api_put, url, body, auth);
    yield put({
      type: UPDATE_UNIT_TANKS,
      payload: response
    })
    yield put(openSnackbar("Cambio de configuración éxitoso.", "success"));
  } catch (message) {
    yield put({
      type: ERROR_DISPENSER_CONFIG_DISPENSERS,
      payload: {
        message,
      },
    });
  }
}
function* sendImei(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, body, idUnit },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/dispensers/${id}/user`;
  try {
    const { imei } = yield call(api_put, url, body, auth);
    yield put({
      type: UPDATE_DISPENSER_IMEI,
      payload: {
        idUnit,
        id,
        imei
      }
    })

    yield put(openSnackbar("Cambio de IMEI éxitoso.", "success"));
  } catch (message) {
    yield put({
      type: ERROR_DISPENSER_CONFIG_DISPENSERS,
      payload: {
        message,
      },
    });
  }
}
function* dispensersSaga() {
  // yield takeLatest(LOAD_DATA_DISPENSERS, fetchData);
  yield takeLatest(SEND_DISPENSER_CONFIG_DISPENSERS, sendConfigDispenser);
  yield takeLatest(SEND_IMEI_DISPENSERS, sendImei);
}

export {
  // reducer
  dispensersReducer,
  // actions
  clearError,
  clearSuccess,
  sendImeiDispenserAction,
  setSuccess,
  setConfigFilter,
  setConfigPage,
  setConfigPageSize,
  setConfigSorted,
  sendDispensersConfig,
  // saga
  dispensersSaga,
};
